import {ConstraintsCollection, MessageTemplateFilterModel, MessagingDistributionChannelsEnum} from '@spa/api';
import {ComponentTypesEnum} from 'appShared/enums';
import {Pagination, ReportTableColumn, ReportTableConfigInterface, ReportTableData} from 'appShared/components';
import {FilterControlInterface} from 'appShared/interfaces';
import {AutocompleteControl, BaseControl, Helper, SelectControl} from 'appShared/classes';
import {
    MessageTemplateFieldNameApprovedBy,
    MessageTemplateFieldNameAuthor,
    MessageTemplateFieldNameCompany,
    MessageTemplateFieldNameDepartment,
    MessageTemplateFieldNameDistributionChannels,
    MessageTemplateFieldNameID,
    MessageTemplateFieldNameStatus,
    MessageTemplateFieldNameTemplateName,
    prepareCompanyFilterControl,
    prepareStatusFilterControl
} from 'appAssets/selectors';

export const PanelSettingsMessagingMessageTemplatesFilterControls = (): FilterControlInterface[] => {
    return [
        prepareStatusFilterControl(MessageTemplateFilterModel.getStatusSelector()),
        {
            name: MessageTemplateFilterModel.getNameSelector(),
            placeholder: MessageTemplateFieldNameTemplateName,
            controls: [
                new BaseControl({
                    name: MessageTemplateFilterModel.getNameSelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameTemplateName,
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 2,
        },
        prepareCompanyFilterControl(),
        {
            name: MessageTemplateFilterModel.getCreatedBySelector(),
            placeholder: MessageTemplateFieldNameAuthor,
            controls: [
                new BaseControl({
                    name: MessageTemplateFilterModel.getCreatedBySelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameAuthor,
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 5,
        },
        {
            name: MessageTemplateFilterModel.getApprovedBySelector(),
            placeholder: MessageTemplateFieldNameApprovedBy,
            controls: [
                new BaseControl({
                    name: MessageTemplateFilterModel.getApprovedBySelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameApprovedBy,
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 6,
        },
        {
            name: MessageTemplateFilterModel.getDepartmentSelector(),
            placeholder: MessageTemplateFieldNameDepartment,
            controls: [
                new AutocompleteControl({
                    name: MessageTemplateFilterModel.getDepartmentSelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameDepartment,
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [],
                }),
            ],
            sortIndex: 7,
        },
        {
            name: MessageTemplateFilterModel.getDistributionChannelsSelector(),
            placeholder: MessageTemplateFieldNameDistributionChannels,
            controls: [
                new SelectControl({
                    name: MessageTemplateFilterModel.getDistributionChannelsSelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameDistributionChannels,
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: Object.values(MessagingDistributionChannelsEnum).map((key: string) => {
                        return {
                            label: Helper.textsHelper().getMessagingDisrtibutionChannelName(key),
                            value: key
                        };
                    }),
                    multiple: true
                }),
            ],
            sortIndex: 8,
        },
    ];
};

export const PanelSettingsMessagingMessageTemplatesDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getCustomerIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getDepartmentSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getDistributionChannelsSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getCreatedBySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getApprovedBySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateFilterModel.getStatusSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const PanelSettingsMessagingMessageTemplatesDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: MessageTemplateFieldNameID,
            selector: MessageTemplateFilterModel.getIdSelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameTemplateName,
            selector: MessageTemplateFilterModel.getNameSelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameCompany,
            selector: MessageTemplateFilterModel.getCustomerIdSelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameDepartment,
            selector: MessageTemplateFilterModel.getDepartmentSelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameDistributionChannels,
            selector: MessageTemplateFilterModel.getDistributionChannelsSelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameAuthor,
            selector: MessageTemplateFilterModel.getCreatedBySelector(),
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameApprovedBy,
            selector: MessageTemplateFilterModel.getApprovedBySelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameStatus,
            selector: MessageTemplateFilterModel.getStatusSelector()
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false
};

export const MessagingMessageTemplatesInitialFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    return new MessageTemplateFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        MessageTemplateFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );
};
